import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-logout',
  imports: [TranslateModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {

  // This method is used to initialize the class instance using router
  constructor(
    private router: Router
  ) {

  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    // Save selected language
    let lang = localStorage.getItem("selectedLang");
    sessionStorage.clear();
    localStorage.clear();
    // Restore language
    if (lang) {
      localStorage.setItem("selectedLang", lang);
    }
    setTimeout(() => {
      this.router.navigate(["/login"]);
    }, 2000);
  }

}
